import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import { PartyForCreation } from '../../interfaces/parties/party-for-creation';
import { ReusableParty } from '../../interfaces/reusable-parties/reusable-party';
import { ReusablePartyLink } from '../../interfaces/reusable-parties/reusable-party-link';
import { PartyLink } from '../../interfaces/parties/party-link';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'lib-handle-existing-party',
    templateUrl: './handle-existing-party.component.html',
    styleUrls: ['./handle-existing-party.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HandleExistingPartyComponent {
  private readonly transloco = inject(TranslocoService);
    selectedExistingPartyID: string = '';
    @Input() country: string = '';
    @Input() jurisdiction: string = '';
    @Input() existingParties: ReusableParty[] = [];
    private _buttonText?: string;
    @Input() set buttonText(value: string | null | undefined) { this._buttonText = value ?? undefined; }
    get buttonText(): string { return this._buttonText ?? this.transloco.translate('common.labels.addReusableParty'); }
    @Output() existingPartySavedEvent = new EventEmitter<PartyForCreation>();
    @Output() existingLinkedPartiesSavedEvent = new EventEmitter<PartyForCreation[]>();

    hasExistingParties(): boolean {
        return this.existingParties.length > 0;
    }

    saveExistingParty() {
        var party = this.existingParties.find(p => p.id == this.selectedExistingPartyID)!;
        let existingParty = this.buildParty(party);

        if (party.linkedReusableParties && party.linkedReusableParties.length > 0) {
            let partiesToSave: PartyForCreation[] = [existingParty];
            party.linkedReusableParties.forEach(link => {
                let linkedParty = this.buildParty(link.linkedReusableParty);
                partiesToSave.push(linkedParty);
            });
            this.existingLinkedPartiesSavedEvent.emit(partiesToSave);
        } 
        else {
            this.existingPartySavedEvent.emit(existingParty);
        }

        this.selectedExistingPartyID = "";
    }

    buildParty(party: ReusableParty): PartyForCreation {
        var reusableRegistryCodes = party.reusablePartyCodes?.filter(p => p.country == this.country && p.jurisdiction == this.jurisdiction);
        let existingParty: PartyForCreation = {
            busName: party.busName ?? null,
            busNumber: "",
            firstName: party.firstName ?? null,
            middleName: party.middleName ?? null,
            lastName: party.lastName ?? null,
            isEstate: party.isEstate ?? null,
            dateOfBirth: null, //DOB missing
            priority: 0,
            reusableRegistryCode: (reusableRegistryCodes?.length ?? 0) > 0 ? reusableRegistryCodes![0].code : null, //Registry Code Missing
            partyTypeID: party.partyTypeID,
            partySubType: null,
            generationID: null,
            externalEntity: null,
            contactDetails: party.contactDetails,
        };

        return existingParty;
    }

    getDisplayName(reusableParty: ReusableParty): string | null {
        if (reusableParty.linkedReusableParties?.length ?? 0 > 0) {
            return `${reusableParty.fullName} (${reusableParty.linkedReusableParties?.at(0)?.linkedReusableParty.fullName})`;
        } else {
            return reusableParty.fullName;
        }
    }
}